export default __webpack_public_path__ + "static/media/LECTURE_RGB.438db4fa.jpg";